import carolinaPng from "./hosts/Carolina@300x.png";
import zeeshanPng from "./hosts/Zeeshan@300x.png";
import guilhermePng from "./hosts/Guilherme@300x.png";
import carolinamp4 from "./hosts/Carolina.mp4";
import zeeshanmp4 from "./hosts/Zeeshan.mp4";
import guilhermemp4 from "./hosts/Guilherme.mp4";

import agilent from "./Sponsors/agilent.svg";
import Batelle from "./Sponsors/Batelle.svg";
import IDT from "./Sponsors/IDT.svg";
import NEB from "./Sponsors/NEB.png";
import OpenPhil from "./Sponsors/Open.svg";
import IDTC from "./Sponsors/IDTColor.svg";
import BenchlingC from "./Sponsors/BenchlingColor.svg";
import OpenPhilC from "./Sponsors/OpenColor.png";
import TwistC from "./Sponsors/TwistColor.svg";
import GinkgoC from "./Sponsors/GinkgoColor.svg";
import BeckmanC from "./Sponsors/Beckman.jpg";
import Beckman from "./Sponsors/BeckmanCoulter_white.png";
import Benchling from "./Sponsors/benchling.svg";
import Ginkgo from "./Sponsors/Ginkgo_Bioworks_logo_white.svg";
import Twist from "./Sponsors/Sponsor_twist white.svg";

export {
  carolinaPng,
  zeeshanPng,
  guilhermePng,
  carolinamp4,
  zeeshanmp4,
  guilhermemp4,
  agilent,
  NEB,
  Batelle,
  IDT,
  OpenPhil,
  IDTC,
  BenchlingC,
  OpenPhilC,
  TwistC,
  GinkgoC,
  BeckmanC,
  Beckman,
  Twist,
  Ginkgo,
  Benchling,
};
